import { SET_AGENDA_RANGE } from '../constants';
import { AgendaRange } from '../reducers';

export function setAgendaRange(payload: AgendaRange) {
  return {
    type: SET_AGENDA_RANGE,
    payload: payload
  };
}
